/**
 * Schema-driven stretch-mode metadata shared by import, validation and the
 * Property Panel. The option values deliberately match the values consumed by
 * ObjectGroup#getResizeMode().
 */

const LEGACY_STRETCH_MODE_ALIASES = Object.freeze({
    full_stretch: 'full',
    vertical: 'v_stretch',
    horizontal: 'h_stretch',
})

export function stretchModeDefinition(schemaOrNode) {
    const schema = schemaOrNode?.schemaV2 ?? schemaOrNode
    return schema?.properties?.stretch_mode
}

export function stretchModeOptions(schemaOrNode) {
    const options = stretchModeDefinition(schemaOrNode)?.options
    return Array.isArray(options) ? options : []
}

export function stretchModeDefault(schemaOrNode) {
    const definition = stretchModeDefinition(schemaOrNode)
    return definition?.default
}

/**
 * Normalize a value loaded from a design. Old Designer versions used
 * `full_stretch` in the UI and some schemas used `keep_ratio`/`full` as their
 * default. The aliases preserve the old visual behavior while the schema's
 * options array remains the only list of valid values.
 */
export function normalizeStretchMode(schemaOrNode, value) {
    const options = stretchModeOptions(schemaOrNode)
    if (options.length === 0) return undefined

    if (options.includes(value)) return value

    const alias = LEGACY_STRETCH_MODE_ALIASES[value]
    if (alias && options.includes(alias)) return alias

    const fallback = stretchModeDefault(schemaOrNode)
    return options.includes(fallback) ? fallback : undefined
}

export function isValidStretchMode(schemaOrNode, value) {
    return stretchModeOptions(schemaOrNode).includes(value)
}

export function stretchModeLabel(value) {
    return {
        none: 'None',
        keep_ratio: 'Ratio',
        v_stretch: 'Vert',
        h_stretch: 'Horz',
        full: 'Full',
    }[value] ?? value
}
